import React, { useEffect, useMemo, useState } from 'react'
import ReactDOM from 'react-dom'
import { MENU_OPEN_CSS_CLASS } from './constants'
import { GlobalStyle, Lateral, Menu, Overlay } from './styled'

interface Props {
  isVisible: boolean
  onOverlayClick: () => void
}

export const LateralMenu: React.FC<Props> = ({ isVisible, onOverlayClick, children }) => {
  const el = useMemo(() => document.createElement('div'), [])
  const [scrollTop, setScrollTop] = useState(0)

  useEffect(() => {
    if (isVisible) {
      setScrollTop(window.pageYOffset)
      document.documentElement.classList.add(MENU_OPEN_CSS_CLASS)
    } else {
      document.documentElement.classList.remove(MENU_OPEN_CSS_CLASS)
      setScrollTop(oldScrollTop => {
        if (oldScrollTop) {
          window.scrollTo(0, oldScrollTop)
        }

        return 0
      })
    }
  }, [isVisible])

  useEffect(() => {
    document.body.appendChild(el)

    return () => {
      document.body.removeChild(el)
    }
  }, [el])

  return ReactDOM.createPortal(
    <Lateral
      isVisible={isVisible}
    >
      <GlobalStyle
        scrollTop={scrollTop}
      />
      <Menu
        isVisible={isVisible}
      >
        {children}
      </Menu>
      <Overlay
        isVisible={isVisible}
        onClick={onOverlayClick}
      />
    </Lateral>,
    el
  )
}
